window.HistoricoPedidoController = ControllerBase.extend({
    framework: "knockout",
    name: "HistoricoPedidoController",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Filial', prop: 'Filial' },
            { title: 'Nº Orçamento', prop: 'NumeroPedido' },
            { title: 'Cliente', prop: 'RazaoSocialCliente' },
            { title: 'Vendedor', prop: 'Vendedor' },
            { title: 'Data', prop: 'DataPedido', type: 'Date' },
            { title: 'Valor', prop: 'ValorPedido', type: 'Money' }
        ],
        getData: function () {
            return this.orcamento;
        }
    }),

    ajax: function () {
        return {
            url: "/Orcamento/_HistoricoOrcamento",
            type: "post",
            cache: false,
            data: {
                numeroPedido: this.numeroPedido
            }
        };
    },

    initialize: function () {
    },

    dispose: function () {
    },

    carregarPaginador: function (data) {
        var self = this;

        setTimeout(function () {
            this.paginador = new Paginator({
                container: "#page-historico-orcamento",
                data: data,
                pageClickCallback: $.proxy(self.paginar, self)
            });
        });
    },

    paginar: function (e) {
        this.pesquisar(e.page);
    },

    pesquisar: function (pagina) {
        var self = this;

        var filtros = {
            TamanhoPagina: 20,
            NumeroPagina: pagina ? pagina : 1,
            NumeroPedido: this.numeroPedido
        };

        global.ajax({
            url: "/Orcamento/ObterHistoricoOrcamento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros }),
            success: function (data) {
                if (!data || data.HasErrors) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);

                self.model.Historicos(m());
                self.carregarPaginador(data);
            }
        });
    }
});